import styled from '@emotion/styled';

export const HeadlineMedium = styled.h5({
    color: '#040f16',
    fontFamily: "'FT Regola Neue'",
    fontFeatureSettings: "'dlig' on, 'ss03' on",
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: 500,
    letterSpacing: '-0.03rem',
    lineHeight: '2rem',
    margin: 0,
    padding: 0,
});
